export default __webpack_public_path__ + "e9f44272baa648a4db46ec48b24aa693.png";